"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainScopes = exports.OrderGuideEventActions = exports.EventTypes = void 0;
var EventTypes;
(function (EventTypes) {
    EventTypes["OGEvent"] = "OGEvent";
})(EventTypes = exports.EventTypes || (exports.EventTypes = {}));
var OrderGuideEventActions;
(function (OrderGuideEventActions) {
    OrderGuideEventActions["OGCreated"] = "OGCreated";
    OrderGuideEventActions["OGUpdated"] = "OGUpdated";
    OrderGuideEventActions["OGDeleted"] = "OGDeleted";
    OrderGuideEventActions["CreateOG"] = "CreateOG";
    OrderGuideEventActions["UpdateOG"] = "UpdateOG";
    OrderGuideEventActions["DeleteOG"] = "DeleteOG";
})(OrderGuideEventActions = exports.OrderGuideEventActions || (exports.OrderGuideEventActions = {}));
var DomainScopes;
(function (DomainScopes) {
    DomainScopes["MyOrderGuideChanges"] = "MyOrderGuideChanges";
})(DomainScopes = exports.DomainScopes || (exports.DomainScopes = {}));
